import React, { createContext, useContext, useRef, useMemo } from 'react'

type PauseCallback = () => void

interface PlayerRegistry {
  [instanceId: string]: PauseCallback
}

export interface VideoPlayerContextValue {
  register: (id: string, pause: PauseCallback) => void
  unregister: (id: string) => void
  notifyPlay: (id: string) => void
}

const VideoPlayerContext = createContext<VideoPlayerContextValue | null>(null)

export const useVideoPlayerContext = (): VideoPlayerContextValue | null => {
  return useContext(VideoPlayerContext)
}

export const VideoPlayerProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const registryRef = useRef<PlayerRegistry>({})

  const contextValue = useMemo<VideoPlayerContextValue>(
    () => ({
      register(id: string, pause: PauseCallback) {
        registryRef.current[id] = pause
      },
      unregister(id: string) {
        delete registryRef.current[id]
      },
      notifyPlay(id: string) {
        const registry = registryRef.current
        Object.keys(registry).forEach(key => {
          if (key !== id) {
            registry[key]()
          }
        })
      }
    }),
    []
  )

  return (
    <VideoPlayerContext.Provider value={contextValue}>
      {children}
    </VideoPlayerContext.Provider>
  )
}
